import { render, staticRenderFns } from "./IndexBlogPage.vue?vue&type=template&id=6440fc20&scoped=true&"
import script from "./IndexBlogPage.vue?vue&type=script&lang=js&"
export * from "./IndexBlogPage.vue?vue&type=script&lang=js&"
import style0 from "./IndexBlogPage.vue?vue&type=style&index=0&id=6440fc20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6440fc20",
  null
  
)

export default component.exports